<template>
  <div>
    <list
      row-key="CoachId"
      ref="list"
      unit="安全员管理"
      @reset="showTree?$refs.treeSelect.clearHandle():null"
      :expand-all-row="true"
      :page="true"
      :query-params="params"
      :show-checkbox="showCheckbox&&($permission.canEdit()||$permission.canDel()||$permission.canRecord())"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="归属机构" v-if="showTree">
          <tree-select
            ref="treeSelect"
            :props="props"
            :options="TreeData"
            :value="DpId"
            :clearable="true"
            :accordion="true"
            :parentSelect="true"
            placeholder="请选择"
            @node-select="onTreeSelect($event)"
          />
        </el-form-item>
        <el-form-item label="审批状态">
          <el-select v-model="params.Status" clearable>
            <el-option :value="0" label="草稿"/>
            <el-option :value="1" label="待审批"/>
            <el-option :value="2" label="退回"/>
            <el-option :value="3" label="已审批"/>
          </el-select>
        </el-form-item>
        <el-form-item label="备案状态">
          <el-select v-model="params.RecordStatus" clearable>
            <el-option :value="0" label="未备案"/>
            <el-option :value="1" label="备案中"/>
            <el-option :value="2" label="备案失败"/>
            <el-option :value="3" label="备案通过"/>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="params.FullName" clearable placeholder="请填写姓名"></el-input>
        </el-form-item>
        <el-form-item label="准教车型">
          <el-select v-model="params.TeachCarType" clearable>
            <el-option v-for="item in teachList" :key="item.DataId" :value="item.DataName"/>
          </el-select>
        </el-form-item>
        <el-form-item label="任职类型">
          <el-select v-model="params.InType" clearable>
            <el-option :value="0" label="自有"/>
            <el-option :value="1" label="加盟"/>
          </el-select>
        </el-form-item>
        <el-form-item label="任职状态">
          <el-select v-model="params.InStatus" clearable>
            <el-option :value="0" label="在职"/>
            <el-option :value="1" label="离职"/>
          </el-select>
        </el-form-item>
        <el-form-item label="入职日期">
          <el-date-picker
             
            v-model.trim="params.InStartDate"
            placeholder="请选择日期"
            clearable
            value-format="yyyy-MM-dd"
            style="width: 193px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            v-model.trim="params.InEndDate"
            clearable
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 193px"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column label="相片" width="100px" align="center">
          <template slot-scope="{row}">
            <img :src="'/api' + row.CertUrl" style="width: 78px;height: 95px;margin-top:6px;">
          </template>
        </el-table-column>
        <el-table-column prop="FullName" label="姓名">
          <template slot-scope="{row}">
            <span :style="$permission.canRecord()&&row.RecordStatus==0||row.RecordStatus==2?'color:#f11;':''">{{row.FullName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Sex" label="性别">
          <template slot-scope="{row}">
            <span v-if="row.Sex==1">男</span>
            <span v-else-if="row.Sex==2">女</span>
          </template>
        </el-table-column>
        <el-table-column prop="Mobile" label="手机号码" />
        <el-table-column prop="TeachCarType" label="准教车型"/>
        <el-table-column prop="InType" label="任职类型">
          <template slot-scope="{row}">
            <span v-if="row.InType==0">自有</span>
            <span v-else-if="row.InType==1">加盟</span>
          </template>
        </el-table-column>
        <el-table-column prop="InDate" label="入职日期">
          <template slot-scope="{row}">
            {{$commonJs.toDateString(row.InDate)}}
          </template>
        </el-table-column>
        <el-table-column prop="InStatus" label="任职状态">
          <template slot-scope="{row}">
            <span v-if="row.InStatus==0">在职</span>
            <span v-else-if="row.InStatus==1">离职</span>
          </template>
        </el-table-column>
        <el-table-column prop="DpName" label="归属机构" min-width="140"/>
        <el-table-column prop="Status" label="审批状态" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="info" v-if="row.Status==0">草稿</el-tag>
            <el-tag type="warning" v-else-if="row.Status==1">待审批</el-tag>
            <el-tag type="danger" v-else-if="row.Status==2">退回</el-tag>
            <el-tag type="success" v-else-if="row.Status==3">已审批</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="RecordStatus" label="备案状态" width="90" align="center">
          <template slot-scope="{row}">
            <span v-if="row.RecordStatus==0" style="color:#f11;">未备案</span>
            <span v-else-if="row.RecordStatus==1">备案中</span>
            <span v-else-if="row.RecordStatus==2" style="color:#f11;">备案失败</span>
            <span v-else-if="row.RecordStatus==3">备案通过</span>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>

import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import treeSelect from "@/components/common/treeSelect";

export default {
  mixins: [listMixin],
  components: {
    list,
    treeSelect
  },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true
    },
    showTree: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      api: require("@/api/schoolmanage/coach").default,
      basicApi: require("@/api/basic/data").default,
      dpApi: require("@/api/basic/dp").default,
      params: {
        CoachType: 1,
        DpIdChain: "",
        FullName: "",
        Status: null,
        RecordStatus: null,
        TeachCarType: "",
        InType: null,
        InStatus: null,
        InStartDate: "",
        InEndDate: "",
      },
      TreeData: [],
      teachList: [],
      DpId: null,
      props: {
        value: "DpId",
        label: "DpName",
        children: "children",
      },
      isMB: this.$store.state.isMB,
    };
  },
  beforeMount() {
    this.basicApi.list({ ClassName:"准教车型", Status:1 }).then(res => {
      this.teachList = res.Data
    });
    this.dpApi.getAuthList({ DpTypes: [2,3], Status: 3, NoReturnParent: true }).then((res) => {
      this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
    });
  },
  methods: {
    onTreeSelect(t) {
      if (!t) {
        this.params.DpIdChain = "";
        this.DpId = null;
      } else {
        this.params.DpIdChain = t.IdChain;
        this.DpId = t.DpId;
      }
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>